import { Address } from '../../model/address.model';
import { Contact, ContactAccount } from '../../model/contact.model';
import * as LabsysContactActions from './labsys-contact.actions';
import * as AuthActions from '../auth/auth.actions';
import { AuthService } from '@app/services/auth.service';

export interface State {
    loggedInContact: Contact;
    loggedInContactId: number;
    addressSuggestions: Address[];
    isContactChecked: boolean;
    loadingContact: boolean;
}

const initialState = {
    loggedInContact: AuthService.getLoggedInContactFromLocalStorage(),
    loggedInContactId: null,
    addressSuggestions: [],
    isContactChecked: false,
    loadingContact: false
};

export function ContactReducer(state = initialState, action: LabsysContactActions.LabsysContactActions | AuthActions.AuthActions) {
    switch (action.type) {

    case LabsysContactActions.GET_LOGGED_IN_CONTACT:
        return {
            ...state,
            loadingContact: true
        };
    case LabsysContactActions.SET_LOGGED_IN_CONTACT:
        return {
            ...state,
            loggedInContact: action.loggedInContact,
            // isContactChecked: true,
            loggedInContactId: action.loggedInContact.contactId,
            loadingContact: false
        };
    case LabsysContactActions.RESET_LOGGED_IN_CONTACT:
        return {
            ...state,
            loggedInContact: null,
            isContactChecked: false
        };
    case LabsysContactActions.SET_DELIVERY_ADDRESS_SUGGESTIONS:
        return {
            ...state,
            addressSuggestions: action.addresses
        };

    case LabsysContactActions.CLEAR_DELIVERY_ADDRESS_SUGGESTIONS:
        return {
            ...state,
            addressSuggestions: []
        };
    case LabsysContactActions.SET_IS_CONTACT_CHECKED:
        return {
            ...state,
            isContactChecked: action.value,
            loadingContact: false
        };
    case AuthActions.USER_INFO_LOADED:
        return {
            ...state,
            loggedInContact: action.contact,
            loggedInContactId: action.contact.contactId,
            isContactChecked: true,
            loadingContact: false
        };
    case AuthActions.CLEAR_ALL_AUTH_DATA:
        return {
            ...state,
            loggedInContact: null,
            loggedInContactId: null,
            loadingContact: false
        };
    case LabsysContactActions.SET_TC_PORTAL_CONTACT:
        return {
            ...state,
            loggedInContact: {
                ...state.loggedInContact,
                portalTcAccepted: action.value
            }
        };
    default:
        return state;
    }
}

// selectors
export const deliveryAddressSuggestions = (state: State) => state.addressSuggestions;
export const getLoadingContact = (state: State) => state.loadingContact;
export const getLoggedInContact = (state: State) => state.loggedInContact;
export const getLoggedInContactId = (state: State) => state.loggedInContactId;
export const getIsContactChecked = (state: State) => state.isContactChecked;

export const getLoggedInContactHasOrganization = (state: State) => state.loggedInContact ?
    (state.loggedInContact.organisation ?
        state.loggedInContact.organisation.name !== null && state.loggedInContact.organisation.id : false) : false;
